import {
  makeCommentHistory,
  makeComment,
  makeCommentThread,
  makeReplyComment,
  makeReplyBranch,
  addReplyBranchToThread,
} from './comment';
import { makeStackNotification, makeNotification, makeNCNotification } from './notification';
import { makeCommission, makeCommissionDeviation } from './commission';
import { makePremiumContentDeviation } from './premiumContent';
import { makeForum } from './forum';
import { makePoll, makePollDeviation } from './poll';
import { makeStatus, makeStatusDeviation } from './status';
import { makeEmptyDeviation, getDeviationBackground } from './deviation';
import { generateAdditionalMedia, deviationToAdditionalMedia } from './multiImageDeviation';
import { makeEditorText, makeTiptapEditorText } from './editorText';
import { makeGroupnote } from './groupnote';
import { makeNotes } from './notes';
import { makeDiscount } from './discount';
import { extendDeviation } from './extendedDeviation';

export default {
  makeCommentHistory,
  makeDiscount,
  makeComment,
  makeCommentThread,
  makeReplyComment,
  makeReplyBranch,
  addReplyBranchToThread,
  makeNotification,
  makeNCNotification,
  makeStackNotification,
  makeCommission,
  makeCommissionDeviation,
  makeForum,
  makePoll,
  makePollDeviation,
  makeStatus,
  makeStatusDeviation,
  makeEmptyDeviation,
  getDeviationBackground,
  generateAdditionalMedia,
  deviationToAdditionalMedia,
  makePremiumContentDeviation,
  makeEditorText,
  makeTiptapEditorText,
  makeGroupnote,
  makeNotes,
  extendDeviation,
};
